import { groupBy, isUndefined } from "lodash"
import React, { useState } from "react"
import { ChevronDown, ChevronUp, X } from "react-bootstrap-icons"
import { useTranslation } from "react-i18next"
import { Link, useLocation } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../app/hooks"
import Logo from "../../../assets/parcel_hub_logo.svg"
import { ADMIN_MENU } from "../../../constants/constants"
import { handleMenuButtonClick } from "../../../containers/Nav"
import { RootState } from "../../../store"
import { setSideBarState } from "../../../store/auth.store"

const Sidebar = () => {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const { t } = useTranslation()
    const { userInfo, sideBarState } = useAppSelector((state: RootState) => state.auth)
    const [moduleToShow, setModuleToShow] = useState("")
    const allMenusWithOutAdmin = userInfo?.GroupMenu?.map((gm: Record<string, any>) => {
        if (!ADMIN_MENU.includes(gm.Menu?.Module?.name)) {
            return gm.Menu
        }
    }).filter((gm: Record<string, any>) => !isUndefined(gm))
    const adminMenu = userInfo?.GroupMenu?.find((gm: Record<string, any>) => {
        if (ADMIN_MENU.includes(gm.Menu?.Module?.name)) {
            return gm.Menu
        }
    })?.Menu

    const adminMenus = userInfo?.GroupMenu?.filter((gm: Record<string, any>) => {
        if (gm.Menu?.parent_id === adminMenu?.id) {
            return gm.Menu
        }
    })?.map((gm: Record<string, any>) => gm.Menu)

    const menusGroupedByModules = groupBy([...allMenusWithOutAdmin, ...adminMenus], "Module.name")

    const handleCloseMenu = () => {
        if (sideBarState) {
            handleMenuButtonClick()
            dispatch(setSideBarState(!sideBarState))
        }
    }

    return (
        <div className="sidebar">
            <div className="d-sm-block d-none logo_content d-flex justify-content-center align-items-center mb-3">
                <Link to="/" style={{ textDecoration: "none" }}>
                    <div className="logo" style={{ textAlign: "center" }}>
                        <img
                            style={{ textAlign: "center", marginLeft: "5px" }}
                            className="icon"
                            src={Logo}
                            alt="logo"
                        />
                        <div className="logo_name">{t("Parcel Hub")}</div>
                    </div>
                </Link>
            </div>
            {sideBarState && (
                <div className="mobile-sidebar-header d-block d-sm-none">
                    <X
                        color="#fff"
                        size={40}
                        id="close-sidebar-btn"
                        className="tr-pointer arrow-icon d-inline"
                        onClick={() => handleCloseMenu()}
                    />
                </div>
            )}
            <ul id="side-menu" className={`nav_list text-start ${sideBarState ? "pt-3 h-100" : ""}`}>
                {Object.keys(menusGroupedByModules).map((key: string) => (
                    <div
                        key={`module-${key}`}
                        className={`mb-4 ${moduleToShow === key ? "active-sidebar-link" : ""}`}>
                        <p
                            className={`text-white pt-2 module d-flex justify-content-between align-items-center tr-pointer mb-3`}
                            data-bs-toggle="collapse"
                            data-target={`#module-${key}`}
                            onClick={() => {
                                if (moduleToShow !== key) {
                                    setModuleToShow(key)
                                } else {
                                    setModuleToShow("")
                                }
                            }}>
                            <span>{key}</span>
                            {moduleToShow === key ? (
                                <ChevronUp color="#1e88e5" size={10} className="arrow-icon d-inline" />
                            ) : (
                                <ChevronDown color="#fff" size={10} className="arrow-icon d-inline" />
                            )}
                        </p>

                        {menusGroupedByModules[key].map((menu: Record<string, any>, index: number) => (
                            <ul
                                key={`menu-${index}-${key}`}
                                id={`module-${key}`}
                                className={`text-start collapse ${
                                    moduleToShow === key ? "show" : "list-collapsed"
                                }`}>
                                <li
                                    className={`pt-2 ${
                                        location.pathname === menu?.route
                                            ? "active-sidebar-link sidebar-li active-menu"
                                            : "sidebar-li active-sidebar-link"
                                    } module-menu`}>
                                    <Link to={menu?.route} onClick={() => handleCloseMenu()}>
                                        {menu?.icon && menu?.icon !== "" && (
                                            <img
                                                className="icon d-inline mx-2"
                                                src={`${process?.env?.REACT_APP_BASE_URL_USERS}${menu?.icon}`}
                                                alt={menu?.name}
                                            />
                                        )}
                                        <span className="links_name">{menu?.name}</span>
                                    </Link>
                                    <span className="tooltip">{t(menu?.name)}</span>
                                </li>
                            </ul>
                        ))}
                    </div>
                ))}
            </ul>
        </div>
    )
}

export default Sidebar
